import { useContext } from 'react';
import { HeaderInfoContext } from '../context';

export const useHeaderInfo = () => useContext(HeaderInfoContext);
